import React, { Component } from 'react';
import ModalCuotas from '../Ventas/ModalCuotas.js';
import ModalQRCuotaScanner from '../../components/Pagar/ModalQRCuotaScanner/ModalQRCuotaScanner.js';
import { Context } from '../../components/Pagar/constants.js';

/**
 * ModalQRVentaCuotaScanner
 *
 * Setup inicial para ModalQRCuotasScanner, es para especificar que se paga
 * la cuota de una venta.
 */
class ModalQRVentaCuotaScanner extends Component {
    render() {
        return (
            <ModalQRCuotaScanner
                // Es necesarios pasar los this.props (props del componente 
                // padre) para que se actualize el ParadigmaTable.
                {...this.props}
                ModalCuotasProp = {ModalCuotas}
                context={Context.VENTA}
                cuotaIdPropName={"id"}
                contextIdPropName={"idVenta"}
                title={"Escanear QR para cobro de cuota de una venta"}
            />
        );
    }
}

export default ModalQRVentaCuotaScanner;



// WEBPACK FOOTER //
// ./src/views/Cobros/ModalQRVentaCuotaScanner.js